import * as types from './documento.actionTypes';

export default {
  getAnexo: data => ({
    type: types.GET_ANEXO,
    payload: data,
  }),
  setAnexo: data => ({
    type: types.SET_ANEXO,
    payload: data,
  }),
  setAnexoCustomizado: data => ({
    type: types.SET_ANEXO_CUSTOMIZADO,
    payload: data,
  }),
};
